import { Button, Group } from "@mantine/core";
import { useHotkeys } from "@mantine/hooks";

export const StepNavigationButtons = (props: {
	backText: string | null;
	backOnClick: () => void;
	backIsDisabled: boolean;
	nextText: string | null;
	nextOnClick: () => void;
	nextIsDisabled: boolean;
}) => {
	useHotkeys([
		[
			"Enter",
			() => {
				if (!props.nextIsDisabled) props.nextOnClick();
			}
		],
		[
			"Escape",
			() => {
				if (!props.backIsDisabled) props.backOnClick();
			}
		]
	]);
	return (
		<>
			<Group justify="center">
				{props.backText && (
					<Button
						onClick={props.backOnClick}
						size="lg"
						disabled={props.backIsDisabled}
						variant={props.nextText ? "light" : ""}
					>
						{props.backText.toUpperCase()}
					</Button>
				)}
				{props.nextText && (
					<Button onClick={props.nextOnClick} size="lg" disabled={props.nextIsDisabled}>
						{props.nextText.toUpperCase()}
					</Button>
				)}
			</Group>
		</>
	);
};
